import type {
  EnrollmentProperties,
  RegistrationNextStep,
} from '@/constants/analytics';
import type {
  InstitutionSubscriptionConfig,
  OfferWithDetails,
} from '@/data/catalog/offer/interfaces';

interface EnrollmentSource {
  course?: { id: number; name: string };
  institution?: { id: number; name: string };
  offerId?: number;
  price?: number;
  isFullIncluded?: boolean;
}

export const buildEnrollmentProperties = ({
  course,
  institution,
  offerId,
  price,
  isFullIncluded,
}: EnrollmentSource): EnrollmentProperties => ({
  course_id: course?.id,
  course_name: course?.name,
  offer_id: offerId,
  institution_id: institution?.id,
  institution_name: institution?.name,
  price,
  is_full_included: isFullIncluded,
});

export const buildOfferEnrollmentProperties = (offer?: OfferWithDetails) =>
  buildEnrollmentProperties({
    course: offer?.course,
    institution: offer?.institution,
    offerId: offer?.id,
    price: offer?.sale_price,
    isFullIncluded: offer?.is_full_included,
  });

export const getRegistrationNextStep = (
  config?: InstitutionSubscriptionConfig | null
): RegistrationNextStep => {
  if (config?.link) return 'external_link';
  if (config) return 'institution_email';
  return 'default';
};
